import {
	IGetCameraPieChartResponseData,
	IGetDashboardLineChartsRequestData,
	IGetDashboardLineChartsRespoonse,
	IGetDashboardMetricsRequestData,
	IGetDashboardMetricsResponseData,
	IGetDevicePieChartResponseData,
	IGetPlateTypePieChartRequestData,
	IGetPlateTypePieChartResponseData,
	IGetProcessingTimeLineGraphResponseData,
	IGetViolationRatePieChartResponseData,
	IGetViolationTrendsResponseData,
	IGetViolationTypeStatisticsRequestData,
	IGetViolationTypeStatisticsResponseData,
	IGetInterceptorViolationStatisticsRequestData,
	IGetInterceptorViolationStatisticsResponseData,
	IGetJurisdictionViolationStatisticsRequestData,
	IGetJurisdictionViolationStatisticsResponseData,
	IGetComprehensiveViolationAnalyticsRequestData,
	IGetComprehensiveViolationAnalyticsResponseData,
	IGetChallanStatsResponse,
	IGetChallanStatsRequestData,
	IInterceptorChallanStats,
	IGetChallanMetricsResponse,
	IGetChallanComprehensiveStatsResponse,
	IGetReportsRequestData,
	IGetRegionalSummaryResponse,
	IGetTopViolationsResponse
} from "../../types";
import { getAPIHeaderOptions } from "../../utils/apiUtils";
import { queries } from "./queries.reducer";

const dashboard = queries.injectEndpoints({
	endpoints: (builder) => ({
		// GET DASHBOARD LINE CHART
		getDashboardLineChart: builder.query<IGetDashboardLineChartsRespoonse, IGetDashboardLineChartsRequestData>({
			query: (requestData) => ({
				url: "/analytics/reconlinechart",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET PLATE TYPE PIE CHART
		getPlateTypePieChart: builder.query<IGetPlateTypePieChartResponseData, IGetPlateTypePieChartRequestData>({
			query: (requestData) => ({
				url: "/analytics/piechart",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET DEVICES PIE CHART
		getDevicesPieChart: builder.query<IGetDevicePieChartResponseData[], void>({
			query: () => ({
				url: "/analytics/devicepiechart",
				headers: getAPIHeaderOptions(true),
				method: "GET"
			})
		}),

		// GET CAMERAS PIE CHART
		getCamerasPieChart: builder.query<IGetCameraPieChartResponseData[], void>({
			query: () => ({
				url: "/analytics/camerapiechart",
				headers: getAPIHeaderOptions(true),
				method: "GET"
			})
		}),

		// GET DASHBOARD METRICS
		getDashboardMetrics: builder.query<IGetDashboardMetricsResponseData, IGetDashboardMetricsRequestData>({
			query: (requestData) => ({
				url: "/analytics/mtes-metrics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET PROCESSING TIME LINE GRAPH DATA
		getProcessingTimeLineGraphData: builder.query<
			IGetProcessingTimeLineGraphResponseData,
			IGetDashboardMetricsRequestData
		>({
			query: (requestData) => ({
				url: "/analytics/processing-time-line-graph",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET VIOLATION RATE PIE CHART DATA
		getViolationRatePieChartData: builder.query<IGetViolationRatePieChartResponseData, IGetDashboardMetricsRequestData>(
			{
				query: (requestData) => ({
					url: "/analytics/validation-status-counts",
					headers: getAPIHeaderOptions(true),
					method: "GET",
					params: requestData
				})
			}
		),

		// GET VIOLATION TRENDS DATA
		getViolationTrendsData: builder.query<IGetViolationTrendsResponseData, IGetDashboardMetricsRequestData>({
			query: (requestData) => ({
				url: "/analytics/event/violation-metrics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET VIOLATION TYPE STATISTICS
		getViolationTypeStatistics: builder.query<
			IGetViolationTypeStatisticsResponseData,
			IGetViolationTypeStatisticsRequestData
		>({
			query: (requestData) => ({
				url: "/analytics/mtes/violation-type-statistics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET INTERCEPTOR VIOLATION STATISTICS
		getInterceptorViolationStatistics: builder.query<
			IGetInterceptorViolationStatisticsResponseData,
			IGetInterceptorViolationStatisticsRequestData
		>({
			query: (requestData) => ({
				url: "/analytics/mtes/interceptor-violation-statistics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET JURISDICTION VIOLATION STATISTICS
		getJurisdictionViolationStatistics: builder.query<
			IGetJurisdictionViolationStatisticsResponseData,
			IGetJurisdictionViolationStatisticsRequestData
		>({
			query: (requestData) => ({
				url: "/analytics/mtes/jurisdiction-violation-statistics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET COMPREHENSIVE VIOLATION ANALYTICS
		getComprehensiveViolationAnalytics: builder.query<
			IGetComprehensiveViolationAnalyticsResponseData,
			IGetComprehensiveViolationAnalyticsRequestData
		>({
			query: (requestData) => ({
				url: "/analytics/mtes/comprehensive-violation-analytics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET CHALLAN STATS
		getChallanStats: builder.query<IGetChallanStatsResponse, IGetChallanStatsRequestData>({
			query: (requestData) => ({
				url: "/analytics/mtes/jurisdiction-offence-challan-statistics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET INTERCEPTOR CHALLAN STATS
		getInterceptorChallanStats: builder.query<IInterceptorChallanStats, IGetChallanStatsRequestData>({
			query: (requestData) => ({
				url: "/analytics/mtes/interceptor-challan-statistics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET CHALLAN METRICS
		getChallanMetrics: builder.query<IGetChallanMetricsResponse, IGetChallanStatsRequestData>({
			query: (requestData) => ({
				url: "/analytics/mtes/challan-dashboard-metrics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET CHALLAN COMPREHENSIVE STATS
		getChallanComprehensiveStats: builder.query<IGetChallanComprehensiveStatsResponse, IGetChallanStatsRequestData>({
			query: (requestData) => ({
				url: "/analytics/mtes/comprehensive-challan-analytics",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET REGIONAL SUMMARY
		getRegionalSummary: builder.query<IGetRegionalSummaryResponse, IGetReportsRequestData>({
			query: (requestData) => ({
				url: "/analytics/reports/regional-summary",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET TOP VIOLATIONS
		getTopViolations: builder.query<IGetTopViolationsResponse, IGetReportsRequestData>({
			query: (requestData) => ({
				url: "/analytics/reports/top-violations",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET INACTIVE REGIONS
		getInactiveRegions: builder.query<IGetRegionalSummaryResponse, IGetReportsRequestData>({
			query: (requestData) => ({
				url: "/analytics/reports/inactive-interceptors",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		})
	})
});

export const {
	// GET DASHBOARD LINE CHART
	useGetDashboardLineChartQuery,
	// GET PLATE TYPE PIE CHART
	useGetPlateTypePieChartQuery,
	// GET DEVICES PIE CHART
	useGetDevicesPieChartQuery,
	// GET CAMERAS PIE CHART
	useGetCamerasPieChartQuery,
	// GET DASHBOARD METRICS
	useGetDashboardMetricsQuery,
	// GET PROCESSING TIME LINE GRAPH DATA
	useGetProcessingTimeLineGraphDataQuery,
	// GET VIOLATION RATE PIE CHART DATA
	useGetViolationRatePieChartDataQuery,
	// GET VIOLATION TRENDS DATA
	useGetViolationTrendsDataQuery,
	// GET VIOLATION TYPE STATISTICS
	useGetViolationTypeStatisticsQuery,
	// GET INTERCEPTOR VIOLATION STATISTICS
	useGetInterceptorViolationStatisticsQuery,
	// GET JURISDICTION VIOLATION STATISTICS
	useGetJurisdictionViolationStatisticsQuery,
	// GET COMPREHENSIVE VIOLATION ANALYTICS
	useGetComprehensiveViolationAnalyticsQuery,
	// GET CHALLAN STATS
	useGetChallanStatsQuery,
	// GET INTERCEPTOR CHALLAN STATS
	useGetInterceptorChallanStatsQuery,
	// GET CHALLAN METRICS
	useGetChallanMetricsQuery,
	// GET CHALLAN COMPREHENSIVE STATS
	useGetChallanComprehensiveStatsQuery,
	// GET REGIONAL SUMMARY
	useGetRegionalSummaryQuery,
	// GET TOP VIOLATIONS
	useGetTopViolationsQuery,
	// GET INACTIVE REGIONS
	useGetInactiveRegionsQuery
} = dashboard;
